import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=ddc47222&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports